import React from 'react';
import PropTypes from 'prop-types';
import Input from 'react-toolbox/lib/input/Input';
import Chip from 'react-toolbox/lib/chip/Chip';
import Avatar from 'react-toolbox/lib/avatar/Avatar';
import {ThreeInputGroup} from '../../Styled';

const Registration = ({name, setName, phone, setPhone, email, setEmail}) => (
    <form>
        <div style={{marginTop: '50px'}}>
            <Chip><Avatar icon='fingerprint'/>TELL US ABOUT YOU</Chip>
            <ThreeInputGroup>
                <Input type='text' label='Name' name='name' autoComplete='name' required
                       value={name} onChange={setName}/>
                <Input type='tel' label='Phone' name='phone' autoComplete='tel' required
                       value={phone} onChange={setPhone}/>
                <Input type='email' label='Email' name='email' autoComplete='email' required
                       value={email} onChange={setEmail}/>
            </ThreeInputGroup>
        </div>
    </form>
);

Registration.propTypes = {
    name:     PropTypes.string,
    setName:  PropTypes.func.isRequired,
    phone:    PropTypes.string,
    setPhone: PropTypes.func.isRequired,
    email:    PropTypes.string,
    setEmail: PropTypes.func.isRequired
};

export default Registration;



// WEBPACK FOOTER //
// ./src/app/tours/components/Registration.js